import {Component, ViewChild} from '@angular/core';
import {AuthService} from '../../../services/auth/auth.service';
import {FiscalService} from '../../../services/fiscal/fiscal.service';
import {MatMenuTrigger} from '@angular/material/menu';
import {CashService} from '../../../services/cash/cash.service';
import {RouteService} from '../../../services/route/route.service';
import moment from 'moment';
import {ViewService} from '../../../services/view/view.service';
import {UtilService} from '../../../services/util/util.service';
import {NumericInputType} from '../../../components/forms/numeric-input/numeric-input.component';

@Component({
  selector: 'app-fiscal-menu',
  templateUrl: './fiscal-menu.component.html',
  styleUrls: ['./fiscal-menu.component.scss']
})
export class FiscalMenuComponent {
  @ViewChild('fiscalMenuBtn', {read: MatMenuTrigger}) public fiscalMenuTrigger: MatMenuTrigger;
  @ViewChild('cashMenuBtn', {read: MatMenuTrigger}) public cashMenuTrigger: MatMenuTrigger;
  public cashIn: number;
  public cashOut: number;
  public cashInFiscal: number;
  public cashOutFiscal: number;
  public moment = moment;

  constructor(
    public authService: AuthService,
    public routeService: RouteService,
    public fiscalService: FiscalService,
    public cashService: CashService,
    public viewService: ViewService
  ) { }

  runCashIn(event: KeyboardEvent = null): void {
    if (!event || event.key === UtilService.KEY_ENTER) {
      if (this.fiscalService.isReady) {
        this.fiscalService.cashIn(this.cashInFiscal);
        this.fiscalMenuTrigger.closeMenu();
        this.cashInFiscal = null;
      } else {
        this.cashService.cashIn(this.cashIn);
        this.cashMenuTrigger.closeMenu();
        this.cashIn = null;
      }
    }
  }

  runCashOut(event: KeyboardEvent = null): void {
    if (!event || event.key === UtilService.KEY_ENTER) {
      if (this.fiscalService.isReady) {
        this.fiscalService.cashOut(this.cashOutFiscal);
        this.fiscalMenuTrigger.closeMenu();
        this.cashOutFiscal = null;
      } else {
        this.cashService.cashOut(this.cashOut);
        this.cashMenuTrigger.closeMenu();
        this.cashOut = null;
      }
    }
  }

  protected readonly NumericInputType = NumericInputType;
}
